import {
  SHOW_LOADER,
  HIDE_LOADER,
  CHANGE_PAGE_LINK_FROM_HEADER,
  GIGYA_ACTION,
  SHOW_SEARCH_MOBILE,
  IS_PAGE_LOAD,
  SHOW_SURVEY,
  HAVE_UNREAD_MESSAGES,
  HAVE_NEW_MESSAGE,
  SHOW_POPOVER,
  MOBILE_FULL_MODE,
  UNREAD_MESSAGE_COUNT  
} from '../actions/app'

export default function app (state = {
  show_loader: false,
  gigya_action: null,
  redirect_to: null,
  show_search_mobile: false,
  show_survey: false,
  show_popover: false,
  mobileFullMode: false
}, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        show_loader: true
      }
    case HIDE_LOADER:
      return {
        ...state,
        show_loader: false
      }
    case HAVE_UNREAD_MESSAGES:
      return {
        ...state,
        have_unread_messages: action.haveUnreadMessages
      }
    case HAVE_NEW_MESSAGE:
      return {
        ...state,
        lastMessage: action.haveNewMessage
      }
    case CHANGE_PAGE_LINK_FROM_HEADER:
      return {
        ...state,
        page_link_header: action.pageLinkHeader
      }
    case GIGYA_ACTION:
      return {
        ...state,
        gigya_action: action.gigyaAction,
        redirect_to: action.redirectTo
      }
    case SHOW_SEARCH_MOBILE:
      return {
        ...state,
        show_search_mobile: action.showSearchFormMobile
      }
    case IS_PAGE_LOAD:
      return {
        ...state,
        is_page_load: false
      }
    case SHOW_SURVEY:
      return {
        ...state,
        show_survey: !state.show_survey
      }
    case SHOW_POPOVER:
      return {
        ...state,
        show_popover: action.show
      }
    case MOBILE_FULL_MODE:
      return {
        ...state,
        mobileFullMode: !state.mobileFullMode
      }
    case UNREAD_MESSAGE_COUNT:
      return {
        ...state,
        unreadMessageCount: action.count
      }
    default:
      return state
  }
}
